import { render, staticRenderFns } from "./design_po_tna.vue?vue&type=template&id=c6adb0fe"
import script from "./design_po_tna.vue?vue&type=script&lang=js"
export * from "./design_po_tna.vue?vue&type=script&lang=js"
import style0 from "./design_po_tna.vue?vue&type=style&index=0&id=c6adb0fe&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports